var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT @ "+_vm._s(new Date().getFullYear())+"\n    "),_c('a',{attrs:{"href":"https://avajang.com/","target":"_blank","rel":"nofollow"}},[_vm._v(_vm._s(_vm.$t("Avajang")))]),_vm._v("\n    V 1.6.7")])])
}
var staticRenderFns = []

export { render, staticRenderFns }